import * as actionConsts from './msgNotifyActions';
var update = require('react/lib/update');

export const initState = {
  messages: []
};

export default function alertMsgReducer(state = initState, action) {
    switch (action.type) {
      case actionConsts.ADD_ALERT:
        return update(state, {
          messages: {
            $push: [action.msg]
          }
        });
      case actionConsts.DISMISS_ALERT:
        return update(state, {
          messages: {
            $splice: [
              [action.index, 1]
              ]
            }
          });
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/App/MsgNotify/msgNotifyReducer.js